"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PgnGame = (function () {
    function PgnGame() {
        this.headers = [];
        this.history = [];
    }
    PgnGame.prototype.headersMap = function () {
        var result = {};
        for (var _i = 0, _a = this.headers; _i < _a.length; _i++) {
            var header = _a[_i];
            if (header.name && header.value) {
                result[header.name] = header.value;
            }
        }
        return result;
    };
    PgnGame.prototype.moves = function () {
        return this.history.filter(function (m) { return m.san; });
    };
    return PgnGame;
}());
exports.PgnGame = PgnGame;
exports.default = PgnGame;
//# sourceMappingURL=pgnGame.js.map


//////////////////
// WEBPACK FOOTER
// ../chess-modules/modules/chess-game/node_modules/@chess-fu/pgn-parser/dist/src/pgnGame.js
// module id = 176
// module chunks = 0